// common.FeatureGroupRuleKinds: what a package membership rule names.
export const FEATURE_GROUP_RULE_KIND = {
  featureType: 1,
  layerCategory: 2,
  module: 3,
} as const
